import React, { useState } from "react";
import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import {
  DashboardOutlined,
  CalendarOutlined,
  ShoppingCartOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  SettingOutlined,
} from "@ant-design/icons";


const { Sider } = Layout;

const Sidebar = () => {
  const navigate = useNavigate();
  const [selectedKey, setSelectedKey] = useState("dashboard");

  // Map keys to routes
  const keyToRoute = {
    dashboard: "/",
    beneficialPlanning: "/planning/beneficial-planning",
    rmPlanning: "/master/raw-material-planning",
    fgPlanning: "/planning/fg-planning",
    pmPlanning: "/master/pm-planning",
    purchase: "/purchase",
    po_page:"/master/purchase/po-page",
    menuMaster: "/master/menu-master/",
    supplierMaster: "/master/supplier-master",
    mspcMaster: "/master/mspc_basicdetails",
    categoryMaster: "/master/category-master",
    factoryMaster: "/master/factory-master",
    reports: "/reports",
    settings: "/settings",
    purchase:"/master/purchase/po-page",
    jobwork_po:"/jobwork/jobwork_po",
    jobwork_dc:"/jobwork/jobwork_dc",
     rawMaterial: "/master/menu-master/raw-material",      
  servingMaster: "/master/menu-master/serving-master",
  fg_approval:"/approvalscreens/fg-approval",
  pm_approval:"/approvalscreens/pm-approval",
  };

  const menuItems = [
    {
      key: "dashboard",
      icon: <DashboardOutlined />,
      label: "Dashboard",
    },
    {
      key: "planning",
      icon: <CalendarOutlined />,
      label: "Planning",
      children: [
        { key: "beneficialPlanning", label: "Beneficial Planning" },
        { key: "rmPlanning", label: "RM Planning & Calculation" },
        { key: "fgPlanning", label: "FG Planning" },
        { key: "pmPlanning", label: "PM Planning" },
      ],
    },
    {
      key: "purchase",
      icon: <ShoppingCartOutlined />,
      label: "Purchase Order",
      children:[
        {key:"po_page",label:"PO_Page"},
        
      ]
    },
     {
      key: "ApprovalScreens",
      icon: <ShoppingCartOutlined />,
      label: "ApprovalScreens",
      children:[
        {key:"fg_approval",label:"FG_Approval"},
        {key:"pm_approval",label:"PM_Approval"}
      ]
    },
    {
      key: "master",
      icon: <AppstoreOutlined />,
      label: "Master",
      children: [
         {
        key: "menuMaster",
        label: "Menu Master",
        children: [
          { key: "rawMaterial", label: "Raw Material" },    
          { key: "servingMaster", label: "Serving Master" }
        ],
      },
        { key: "supplierMaster", label: "Supplier Master" },
        { key: "mspcMaster", label: "MSPC Master" },
        { key: "categoryMaster", label: "Category Master" },
        { key: "factoryMaster", label: "Factory Master" },
      ],
    },
    {
      key:"jobwork",
      icon:<AppstoreOutlined/>,
      label:"JobWork",
      children:[
        {key:"jobwork_po",label:"JobWork_PO"},
        {key:"jobwork_dc",label:"JobWork_DC"},
      ],

    },
   
    {
      key: "reports",
      icon: <FileTextOutlined />,
      label: "Reports",
    },
    {
      key: "settings",
      icon: <SettingOutlined />,
      label: "Settings",
    },
  ];

  const handleMenuClick = ({ key }) => {
    setSelectedKey(key);
    const route = keyToRoute[key];
    if (route) navigate(route);
  };

  return (
    <Sider
      width={220}
      style={{
        height: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        backgroundColor: "#013a63",
        overflow: "auto",
      }}
    >
      <div
        style={{
          color: "white",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "18px",
          padding: "16px 0",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
          letterSpacing: "1px",
        }}
      >
        KTK ERP
      </div>
      <Menu
        mode="inline"
        theme="dark"
        selectedKeys={[selectedKey]}
        style={{ backgroundColor: "#063253", color: "#fff" }}
        onClick={handleMenuClick}
        items={menuItems}
      />
    </Sider>
  );
};

export default Sidebar;
